import React, {Component} from 'react'
import PropTypes from 'prop-types'
import './NavBar.css'

class Navbar extends Component {
  static defaultProps = {
    onNewRecipe() {}
  }
  
  static propTypes = {
    onNewRecipe: PropTypes.func
  }
  
  render() {
    return (
      <div className = "nav-bar">
      <header>
        <h2 className = "left-side">Jones & Nelsons Recipes</h2>
        <nav>
         
         
          <a className = "about">About</a>
          <a className = "contact">Contact Us</a>
          <a className = "new-recipe" onClick={this.props.onNewRecipe}>New Recipe</a>
          <a className = "home">Home</a>
          
        </nav>
      </header>
      </div>
    );
  }
}

export default Navbar;